export const CRYPTO_SECRET = window.REACT_APP_CRYPTO_SECRET;
export const MSL_API_URL = window.REACT_APP_BASE_URL;
